import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { StyledAnchor } from "shared/components/common/base-link/styles";
import { Icon } from "shared/components/common/icon";
import { transientOptions } from "shared/lib/styles";

import { ArticleComment } from "scmp-app/components/article/article-comment";
import {
  StyledCommentFilledIcon,
  StyledCommentIcon,
} from "scmp-app/components/article/article-comment/styles";
import { ContentBookmark } from "scmp-app/components/content/content-bookmark";

import TrendingIcon from "./content-type-icon/icon-trending.svg";

export const FlexContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
`;

export const VideoIcon = styled(Icon)`
  margin-inline-start: 8px;
`;

export const ContentTypeContainer = styled.div`
  margin-inline-start: 8px;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;

  & + & {
    margin-inline-start: 20px;
  }

  & ${StyledAnchor} {
    margin-inline-start: 16px;
  }
`;

export const StyledContentBookmark = styled(ContentBookmark)`
  inline-size: 15px;
  block-size: 15px;
  margin-inline-start: 16px;
  padding: 0;

  color: #4585ff;
`;

export type StyledArticleCommentProps = {
  $colorVariant?: "default" | "light-action-blue";
  $iconPosition?: "left" | "right";
};

export const StyledArticleComment = styled(ArticleComment, {
  ...transientOptions,
})<StyledArticleCommentProps>`
  ${props => {
    switch (props.$colorVariant) {
      case "light-action-blue":
        return css`
          color: #556bb4;
        `;
      default:
        return null;
    }
  }}

  ${props => {
    switch (props.$iconPosition) {
      case "left":
        return css`
          flex-direction: row-reverse;

          ${StyledCommentFilledIcon}, ${StyledCommentIcon} {
            margin-inline: 0 4px;
          }
        `;
      default:
        return null;
    }
  }}
`;

export const IconTrending = styled(TrendingIcon)`
  inline-size: 18px;
  block-size: 18px;
  margin-inline-end: 6px;
`;
